module.exports = __webpack_public_path__ + "static/media/popup-header-image.2d586b6c.png";